import React from 'react'

export default function LastProjectItem(props) {
    return (
        <div>
            <li className="p-4 pl-7 relative before:absolute before:-left-1 before:top-1/2 before:-translate-y-1/2 before:w-6 before:h-6 before:border-2 before:border-mainBlue before:rounded-full after:absolute after:left-[7px] after:-bottom-4 after:w-[2px] after:h-8 after:bg-mainBlue"><span className={`absolute w-4 h-4 bg-mainBlue rounded-full top-1/2 left-0 -translate-y-1/2 ${props.classes}`} ></span>{props.item}</li>
        </div>
    )
}
